import React from 'react';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { MenuEntry } from '../Forms/types';
import ComponentItem from './ComponentItem';
import clsx from 'clsx';

interface ComponentGroupProps {
  entries: MenuEntry[];
}

const ComponentGroup: React.FC<ComponentGroupProps> = (props) => {
  const { entries } = props;
  const classes = useStyles();

  return (
    <>
      {entries.map((entry) => {
        return (
          <div key={`group:${entry.identifier}-${entry.order}`}>
            <Typography className={classes.componentGroupTitle1}>{entry.title}</Typography>
            {entry.entries ? (
              entry.entries.map((component) => (
                <div key={`component:${component.identifier}-${component.order}`}>
                  <Typography
                    className={clsx(classes.componentGroupTitle2, component.active ? '' : 'disabled')}
                  >
                    {component.title}
                  </Typography>
                  <ComponentItem component={component} />
                </div>
              ))
            ) : (
              <ComponentItem component={entry} />
            )}
          </div>
        );
      })}
    </>
  );
};

export default ComponentGroup;
